import { Modal } from 'antd';

const { confirm, info } = Modal;
export function showConfirm(
  promise: () => void,
  title: string | React.ReactNode,
  content?: string | React.ReactNode,
) {
  confirm({
    title,
    content,
    onOk() {
      promise();
    },
  });
}

export function showAlert(
  promise?: () => void,
  title?: string | React.ReactNode,
  content?: string | React.ReactNode,
  // closable?:boolean,
) {
  info({
    title,
    content,
    onOk() {
      if (promise) promise();
    },
    // closable,
  });
}
